<div [class]="styleClass || class">
  <div
    class="w-full h-full bg-gray-50 flex items-center justify-center"
    [ngClass]="{ hidden: !imageLoader }"
  >
    <i class="pi pi-spin pi-spinner text-sm"></i>
  </div>
  <img
    [ngClass]="{ hidden: imageLoader }"
    [alt]="alt"
    class="{{'w-full h-full object-cover object-center ' + imageClass}}"
    (error)="onImageError()"
    [src]="imgId"
    (load)="onImageLoad()"
  />
</div>
